import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

const PerformanceDateTime = ({ inputRef, setActivityPerformance, activityPerformance, userinternal }) => {
  return (
    <Flatpickr
      ref={inputRef}
      data-enable-time
      options={{
        enableTime: true,
        altInput: true,
        altFormat: "j M, Y H:i",
        dateFormat: "Y-m-d H:i",
        time_24hr: true,
        defaultDate: moment().format("YYYY-MM-DD HH:mm"),
        maxDate: new Date(),
      }}
      id="datepickr"
      onChange={(e) => {
        const date_value = document.getElementById("datepickr").value;
        setActivityPerformance({
          ...activityPerformance,
          date: date_value,
        });
      }}
      disabled={userinternal}
      className={`form-input w-full bg-slate-100 cursor-not-allowed`}
    />
  );
};

export default PerformanceDateTime;
